import PropTypes from 'prop-types';
import React from 'react';

export default class SkirmishLiveStandings extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };
  render() {
    const {title, liveStandings} = this.props.data;
    return (
      <section className="skirmish-live-standings">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <h1>{title}</h1>
              {liveStandings ? (
                <div className="liveStandings" dangerouslySetInnerHTML={{__html: liveStandings}} />
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
